export const connectionSectionDeleteButtonSx = {
    color: "#4A4A4A",
    "&:hover": {
        color: "error.main",
        backgroundColor: "rgba(211, 47, 47, 0.06)",
    },
    "&.Mui-disabled": {
        color: "#4A4A4A",
        opacity: 0.2,
    },
} as const;
